/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

export const transactionPayoutDetailConfig = {
  buttons: {
    key: 'viewInExplorer',
    title: 'View in Blockchain Explorer',
    color: 'primary',
    link: 'https://mumbai.polygonscan.com/tx/0xd42d806d2dc78369bd45068783f0fcf7a965f4b046cc5ca0a79ec8d7a2225bdd',
  },
  heroImage: {
    image: 'https://i.ibb.co/qg0bdp7/polygon-logo.webp',
  },
  listItems: [
    {
      key: 'transactionId',
      title: 'Transaction Id',
      subTitle: '',
      icon: 'https://cdn.iconscout.com/icon/premium/png-256-thumb/insurance-policy-5423901-4526630.png',
    },
    {
      key: 'transactionHash',
      title: 'Transaction Hash',
      subTitle: '',
      icon: 'https://cdn-icons-png.flaticon.com/512/5455/5455381.png',
    },
    {
      key: 'status',
      title: 'Status',
      subTitle: '',
      icon: 'https://s3.ap-south-1.amazonaws.com/io.klefki.parametro/status.png',
    },
    {
      key: 'timestamp',
      title: 'Timestamp',
      subTitle: '',
      icon: 'https://s3.ap-south-1.amazonaws.com/io.vlinder.illustrations/valid-time.png',
    },
  ],
  carouselItems: [
    {
      type: 'qr',
      src: 'https://google.co.in',
    },
  ],
  qrPosterImg:
    'https://s3.ap-south-1.amazonaws.com/io.klefki.parametro/blockchain-receipt.jpg',
};
